import { useMemo, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ResetPassword() {
	const [searchParams] = useSearchParams();
	const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
	const navigate = useNavigate();
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [loading, setLoading] = useState(false);

	const submit = async e => {
		e.preventDefault();
		if (!token) {
			toast.error("Missing reset token");
			return;
		}
		if (newPassword.length < 8) {
			toast.error("Password must be at least 8 characters");
			return;
		}
		if (newPassword !== confirmPassword) {
			toast.error("Passwords do not match");
			return;
		}
		setLoading(true);
		try {
			await axios.post(`${process.env.REACT_APP_API_URL}reset-password`, {
				token,
				newPassword,
			});
			toast.success("Password updated");
			setTimeout(() => navigate("/", { replace: true }), 900);
		} catch (error) {
			toast.error(error?.response?.data?.message || "Could not reset password");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
			<div className="w-full max-w-md rounded-2xl bg-white ring-1 ring-slate-200 p-6">
				<div className="text-xl font-semibold text-slate-900">Reset Password</div>
				<div className="text-sm text-slate-500 mt-1">Enter your new password.</div>
				<form className="mt-5 space-y-3" onSubmit={submit}>
					<input
						type="password"
						placeholder="New password"
						className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
						value={newPassword}
						onChange={e => setNewPassword(e.target.value)}
					/>
					<input
						type="password"
						placeholder="Confirm new password"
						className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
						value={confirmPassword}
						onChange={e => setConfirmPassword(e.target.value)}
					/>
					<button
						disabled={loading}
						className="w-full rounded-lg bg-slate-900 text-white px-3 py-2 text-sm font-medium hover:bg-slate-800"
					>
						{loading ? "Updating..." : "Update password"}
					</button>
				</form>
			</div>
			<ToastContainer position="bottom-right" autoClose={2500} />
		</div>
	);
}
